import { Theme } from '@mui/material/styles';
//
import { InputSelectIcon } from './CustomIcons';

// ----------------------------------------------------------------------

export default function Select(theme: Theme) {
  return {
    MuiSelect: {
      styleOverrides: {
        root: {
          '.Mui-disabled': { opacity: 0.5, background: theme.palette.action.disabledBackground },
        },
      },
      defaultProps: {
        IconComponent: InputSelectIcon,
      },
    },
  };
}
